import { MODULE } from "./splitPurchaseOrders.actionTypes";

export const isSplitOrderModalVisible = (state) =>
  state.getIn([MODULE, "isSplitOrderModalVisible"]);

export const isFetchingStatus = (state) => state.getIn([MODULE, "isFetchingStatus"]);

export const isSavingStatus = (state) => state.getIn([MODULE, "isSavingStatus"]);

export const isConfirmationModalVisible = (state) =>
  state.getIn([MODULE, "isConfirmationModalVisible"]);

export const getProducts = (state) => state.getIn([MODULE, "products"]);
